// src/components/Shared/ModalWrapper.jsx
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ModalWrapper = ({ isOpen, onClose, children, maxWidth = 'max-w-md' }) => {

      // Close on ESC key
      useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

  return (
<AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop - now clickable to close */}
                    <motion.div
                        key="backdrop"
                        className="fixed inset-0 bg-dark-900 bg-opacity-80 z-40 flex items-center justify-center p-4 cursor-pointer"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={onClose}
                    />

                    {/* Modal Content */}
                    <motion.div
                        key="modal-content"
                        className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                    >
                        <div 
                            className={`w-full ${maxWidth} mx-auto pointer-events-auto`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <motion.div 
                                className="bg-dark-600 rounded-2xl p-6 shadow-xl border border-dark-400 relative overflow-hidden"
                                initial={{ y: 20 }}
                                animate={{ y: 0 }}
                            >
                                {children}
                            </motion.div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
  );
};

export default ModalWrapper;